<template>
  <section class="fixed-back">

  </section>
</template>

<script>
export default {
  name: "FixedBackground"
}
</script>

<style scoped>
.fixed-back{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 10%;
  z-index: -1;
  background-image: url("../assets/images/patterns/patternMain.png") ;
  background-repeat: no-repeat;
  /*background-size: 80%;*/
  background-position: top left;
  opacity: 0.7;
}
</style>